<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006">
<p class="_toc" id="_idParaDest-3">Contents<a id="_idTextAnchor000"></a></p>
<p class="toc1"><a href="#/SOE#_idTextAnchor001"><span class="ital">Introduction</span></a> </p>
<p class="toc3">Chapter One:</p>
<p class="toc2"><a href="#/SOE1#_idTextAnchor003">Earth-Based Souls and Interplanetary Souls: The Differences</a> </p>
<p class="toc3"><span class="toc">Chapter Two:</span></p>
<p class="toc2"><a href="#/SOE2#_idTextAnchor004">Life Purpose of Interplanetary Souls</a> </p>
<p class="toc3"><span class="toc">Chapter Three:</span></p>
<p class="toc2"><a href="#/SOE3#_idTextAnchor005">Earth Incarnation Challenges for Interplanetary Souls</a> </p>
<p class="toc3"><span class="toc">Chapter Four:</span></p>
<p class="toc2"><a href="#/SOE4#_idTextAnchor006">Mislabeling and Misunderstanding Interplanetary Souls</a> </p>
<p class="toc3"><span class="toc">Chapter Five:</span></p>
<p class="toc2"><a href="#/SOE5#_idTextAnchor007">Spirit Guides, Senior Elders, and the Interplanetary Council</a> </p>
<p class="toc3"><span class="toc">Chapter Six:</span></p>
<p class="toc2"><a href="#/SOE6#_idTextAnchor008">Soul Archetypes and Past Lives of Interplanetary Souls</a> </p>
<p class="toc3"><span class="toc">Chapter Seven:</span></p>
<p class="toc2"><a href="#/SOE7#_idTextAnchor010">Interplanetary Soul Family Relationships</a> </p>
<p class="toc3"><span class="toc">Chapter Eight:</span></p>
<p class="toc2"><a href="#/SOE8#_idTextAnchor011">Parenting an Interplanetary Soul</a> </p>
<p class="toc3"><span class="toc">Chapter Nine:</span></p>
<p class="toc2"><a href="#/SOE9#_idTextAnchor012">Survival Guide for Interplanetary Souls on Earth</a> </p>
<p class="toc3"><span class="toc">Chapter Ten:</span></p>
<p class="toc2"><a href="#/SOE10#_idTextAnchor013">Essential Action to Evolve Humanity</a> </p>
<p class="toc1"><a href="#/SOE11#_idTextAnchor015"><span class="ital">Appendix: Training in Soul Regression Therapy</span></a></p>
<p class="toc1"><a href="#/SOE12#_idTextAnchor016"><span class="ital">Glossary</span></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?104f6538